import Auth from '../auth';

const AUTH_HEADER_KEYS = [
  'access-token',
  'token-type',
  'client',
  'expiry',
  'uid',
];

const isPresent = value => {
  if (Array.isArray(value)) return value.some(item => isPresent(item));
  return value !== '' && value !== null && value !== undefined;
};

export const compactParams = (params = {}) =>
  Object.entries(params).reduce((acc, [key, value]) => {
    if (!isPresent(value)) return acc;
    if (Array.isArray(value)) {
      acc[key] = value.filter(item => isPresent(item));
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {});

export const authHeaders = () => {
  if (!Auth.hasAuthCookie()) return {};

  try {
    const authData = Auth.getAuthData();
    return AUTH_HEADER_KEYS.reduce((headers, key) => {
      if (authData[key]) headers[key] = authData[key];
      return headers;
    }, {});
  } catch {
    return {};
  }
};

export const requestConfig = (params = {}) => {
  const compactedParams = compactParams(params);
  const config = { headers: authHeaders() };

  if (Object.keys(compactedParams).length) {
    config.params = compactedParams;
  }

  return config;
};

export const queryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(compactParams(params)).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(item => searchParams.append(key, item));
      return;
    }
    searchParams.append(key, value);
  });

  return searchParams.toString();
};

export const withQuery = (path, params = {}) => {
  const query = queryString(params);
  return query ? `${path}?${query}` : path;
};

export const pathJoin = (...segments) =>
  segments
    .filter(segment => isPresent(segment))
    .map(segment => String(segment).replace(/^\/+|\/+$/g, ''))
    .filter(Boolean)
    .join('/');

export const resourcePath = (basePath, ...segments) => {
  const base = String(basePath).replace(/\/+$/g, '');
  const suffix = pathJoin(...segments);
  return suffix ? `${base}/${suffix}` : base;
};
